import { render } from "./RoomCard.vue?vue&type=template&id=540a9830"
import script from "./RoomCard.vue?vue&type=script&lang=js"
export * from "./RoomCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__